import { createAction, createRequestTypes, createRequestAction } from 'utils'

export const UPDATE_USER = '@user/UPDATE_USER'
export const UPDATE_USER_PASSWORD = '@user/UPDATE_USER_PASSWORD'
export const UPDATE_DEVICE_COUNTERS = '@user/UPDATE_DEVICE_COUNTERS'
export const ADD_SYSTEM_TO_USER = '@user/ADD_SYSTEM_TO_USER'
export const DELETE_SYSTEM_FROM_USER = '@user/DELETE_SYSTEM_FROM_USER'
export const DELETE_MULTIPLE_SYSTEMS = '@user/DELETE_MULTIPLE_SYSTEMS'
export const UPLOAD_USER_LOGO = '@user/UPLOAD_USER_LOGO'
export const DELETE_USER_LOGO = '@user/DELETE_USER_LOGO'
export const SEND_USER_OCCURRENCE = '@user/SEND_USER_OCCURRENCE'
export const CONFIRM_USER_NEWS = '@user/CONFIRM_USER_NEWS'
export const CONFIRM_RECIPIENT = '@user/CONFIRM_RECIPIENT'
export const CONFIRM_TRUSTED_USER = '@user/CONFIRM_TRUSTED_USER'
export const CHECK_TRUSTED_USER_STATUS = '@user/CHECK_TRUSTED_USER_STATUS'
export const ADD_ALERT_RECIPIENT = '@user/ADD_ALERT_RECIPIENT'
export const DELETE_ALERT_RECIPIENT = '@user/DELETE_ALERT_RECIPIENT'
export const DELETE_ACCOUNT = '@user/DELETE_ACCOUNT'
export const MANAGE_TRUSTED_USERS = '@user/MANAGE_TRUSTED_USERS'
export const DELETE_COLLABORATIVE_ACCESS = '@user/DELETE_COLLABORATIVE_ACCESS'
export const ADD_TRUSTED_USER = '@user/ADD_TRUSTED_USER'

export const ADD_COLLABORATIVE_ACCOUNT = '@user/ADD_COLLABORATIVE_ACCOUNT'
export const EDIT_COLLABORATIVE_ACCOUNT = '@user/EDIT_COLLABORATIVE_ACCOUNT'
export const UPDATE_USER_REQUEST = createRequestTypes('@user/UPDATE_USER_REQUEST')
export const UPDATE_USER_PASSWORD_REQUEST = createRequestTypes('@user/UPDATE_USER_PASSWORD_REQUEST')
export const ADD_SYSTEM_TO_USER_REQUEST = createRequestTypes('@user/ADD_SYSTEM_TO_USER_REQUEST')
export const DELETE_MULTIPLE_SYSTEMS_REQUEST = createRequestTypes(
  '@user/DELETE_MULTIPLE_SYSTEMS_REQUEST'
)
export const DELETE_SYSTEM_FROM_USER_REQUEST = createRequestTypes(
  '@user/DELETE_SYSTEM_FROM_USER_REQUEST'
)

export const UPLOAD_USER_LOGO_REQUEST = createRequestTypes('@user/UPLOAD_USER_LOGO_REQUEST')
export const DELETE_USER_LOGO_REQUEST = createRequestTypes('@user/DELETE_USER_LOGO_REQUEST')
export const SEND_USER_OCCURRENCE_REQUEST = createRequestTypes('@user/SEND_USER_OCCURRENCE_REQUEST')

export const CONFIRM_USER_NEWS_REQUEST = createRequestTypes('@user/CONFIRM_USER_NEWS_REQUEST')
export const CONFIRM_RECIPIENT_REQUEST = createRequestTypes('@user/CONFIRM_RECIPIENT_REQUEST')
export const CONFIRM_TRUSTED_USER_REQUEST = createRequestTypes('@user/CONFIRM_TRUSTED_USER_REQUEST')
export const CHECK_TRUSTED_USER_STATUS_REQUEST = createRequestTypes(
  '@user/CHECK_TRUSTED_USER_STATUS_REQUEST'
)
export const ADD_ALERT_RECIPIENT_REQUEST = createRequestTypes('@user/ADD_ALERT_RECIPIENT_REQUEST')
export const DELETE_ALERT_RECIPIENT_REQUEST = createRequestTypes(
  '@user/DELETE_ALERT_RECIPIENT_REQUEST'
)
export const DELETE_ACCOUNT_REQUEST = createRequestTypes('@user/DELETE_ACCOUNT_REQUEST')
export const MANAGE_TRUSTED_USERS_REQUEST = createRequestTypes('@user/MANAGE_TRUSTED_USERS_REQUEST')
export const DELETE_COLLABORATIVE_ACCESS_REQUEST = createRequestTypes(
  '@user/DELETE_COLLABORATIVE_ACCESS_REQUEST'
)
export const ADD_COLLABORATIVE_ACCOUNT_REQUEST = createRequestTypes(
  '@user/ADD_COLLABORATIVE_ACCOUNT_REQUEST'
)
export const EDIT_COLLABORATIVE_ACCOUNT_REQUEST = createRequestTypes(
  '@user/EDIT_COLLABORATIVE_ACCOUNT_REQUEST'
)
export const ADD_TRUSTED_USER_REQUEST = createRequestTypes('@user/ADD_TRUSTED_USER_REQUEST')
export const constants = {
  UPDATE_USER,
  UPDATE_USER_PASSWORD,
  ADD_SYSTEM_TO_USER,
  DELETE_SYSTEM_FROM_USER,
  DELETE_MULTIPLE_SYSTEMS,
  UPLOAD_USER_LOGO,
  DELETE_USER_LOGO,
  SEND_USER_OCCURRENCE,
  CONFIRM_USER_NEWS,
  CONFIRM_RECIPIENT,
  ADD_ALERT_RECIPIENT,
  DELETE_ALERT_RECIPIENT,
  DELETE_ACCOUNT,
  MANAGE_TRUSTED_USERS,
  DELETE_COLLABORATIVE_ACCESS,
  ADD_COLLABORATIVE_ACCOUNT,
  EDIT_COLLABORATIVE_ACCOUNT,
  ADD_TRUSTED_USER,

  CONFIRM_TRUSTED_USER,
  CHECK_TRUSTED_USER_STATUS,
  CONFIRM_TRUSTED_USER_REQUEST,
  CHECK_TRUSTED_USER_STATUS_REQUEST,
  UPDATE_USER_REQUEST,
  UPDATE_USER_PASSWORD_REQUEST,
  ADD_SYSTEM_TO_USER_REQUEST,
  DELETE_SYSTEM_FROM_USER_REQUEST,
  DELETE_MULTIPLE_SYSTEMS_REQUEST,
  UPLOAD_USER_LOGO_REQUEST,
  DELETE_USER_LOGO_REQUEST,
  SEND_USER_OCCURRENCE_REQUEST,
  CONFIRM_USER_NEWS_REQUEST,
  CONFIRM_RECIPIENT_REQUEST,
  ADD_ALERT_RECIPIENT_REQUEST,
  DELETE_ALERT_RECIPIENT_REQUEST,
  DELETE_ACCOUNT_REQUEST,
  MANAGE_TRUSTED_USERS_REQUEST,
  DELETE_COLLABORATIVE_ACCESS_REQUEST,
  ADD_COLLABORATIVE_ACCOUNT_REQUEST,
  EDIT_COLLABORATIVE_ACCOUNT_REQUEST,
  ADD_TRUSTED_USER_REQUEST
}

export const updateDeviceCounters = createAction(UPDATE_DEVICE_COUNTERS)
export const addSystemToUser = createAction(ADD_SYSTEM_TO_USER)
export const deleteSystemFromUser = createAction(DELETE_SYSTEM_FROM_USER)
export const deleteMultipleSystems = createAction(DELETE_MULTIPLE_SYSTEMS)
export const updateUser = createAction(UPDATE_USER)
export const updateUserPassword = createAction(UPDATE_USER_PASSWORD)
export const uploadUserLogo = createAction(UPLOAD_USER_LOGO)
export const deleteUserLogo = createAction(DELETE_USER_LOGO)
export const sendUserOccurrence = createAction(SEND_USER_OCCURRENCE)
export const confirmUserNews = createAction(CONFIRM_USER_NEWS)
export const confirmRecipient = createAction(CONFIRM_RECIPIENT)
export const confirmTrustedUser = createAction(CONFIRM_TRUSTED_USER)
export const checkTrustedUserStatus = createAction(CHECK_TRUSTED_USER_STATUS)
export const addAlertRecipient = createAction(ADD_ALERT_RECIPIENT)
export const addTrustedUser = createAction(ADD_TRUSTED_USER)
export const deleteAlertRecipient = createAction(DELETE_ALERT_RECIPIENT)
export const deleteAccount = createAction(DELETE_ACCOUNT)
export const manageTrustedUsers = createAction(MANAGE_TRUSTED_USERS)
export const deleteCollaborativeAccess = createAction(DELETE_COLLABORATIVE_ACCESS)

export const addCollaborativeAccount = createAction(ADD_COLLABORATIVE_ACCOUNT)
export const editCollaborativeAccount = createAction(EDIT_COLLABORATIVE_ACCOUNT)
export const addSystemToUserRequest = createRequestAction(ADD_SYSTEM_TO_USER_REQUEST)
export const deleteSystemFromUserRequest = createRequestAction(DELETE_SYSTEM_FROM_USER_REQUEST)
export const deleteMultipleSystemsRequest = createRequestAction(DELETE_MULTIPLE_SYSTEMS_REQUEST)
export const updateUserRequest = createRequestAction(UPDATE_USER_REQUEST)
export const updateUserPasswordRequest = createRequestAction(UPDATE_USER_PASSWORD_REQUEST)
export const uploadUserLogoRequest = createRequestAction(UPLOAD_USER_LOGO_REQUEST)
export const deleteUserLogoRequest = createRequestAction(DELETE_USER_LOGO_REQUEST)
export const sendUserOccurrenceRequest = createRequestAction(SEND_USER_OCCURRENCE_REQUEST)
export const confirmUserNewsRequest = createRequestAction(CONFIRM_USER_NEWS_REQUEST)
export const confirmRecipientRequest = createRequestAction(CONFIRM_RECIPIENT_REQUEST)
export const confirmTrustedUserRequest = createRequestAction(CONFIRM_TRUSTED_USER_REQUEST)
export const checkTrustedUserStatusRequest = createRequestAction(CHECK_TRUSTED_USER_STATUS_REQUEST)
export const addAlertRecipientRequest = createRequestAction(ADD_ALERT_RECIPIENT_REQUEST)
export const deleteAlertRecipientRequest = createRequestAction(DELETE_ALERT_RECIPIENT_REQUEST)
export const deleteAccountRequest = createRequestAction(DELETE_ACCOUNT_REQUEST)
export const manageTrustedUsersRequest = createRequestAction(MANAGE_TRUSTED_USERS_REQUEST)
export const deleteCollaborativeAccessRequest = createRequestAction(
  DELETE_COLLABORATIVE_ACCESS_REQUEST
)

export const addCollaborativeAccountRequest = createRequestAction(ADD_COLLABORATIVE_ACCOUNT_REQUEST)
export const editCollaborativeAccountRequest = createRequestAction(
  EDIT_COLLABORATIVE_ACCOUNT_REQUEST
)
export const addTrustedUserRequest = createRequestAction(ADD_TRUSTED_USER_REQUEST)

export default {
  updateUser,
  updateUserPassword,
  addSystemToUser,
  deleteSystemFromUser,
  uploadUserLogo,
  deleteUserLogo,
  sendUserOccurrence,
  confirmUserNews,
  confirmRecipient,
  confirmTrustedUser,
  checkTrustedUserStatus,
  addAlertRecipient,
  deleteAlertRecipient,
  deleteAccount,
  manageTrustedUsers,
  deleteCollaborativeAccess,
  addCollaborativeAccount,
  editCollaborativeAccount,
  addTrustedUser,
  deleteMultipleSystems,
  addTrustedUserRequest,
  updateUserRequest,
  updateUserPasswordRequest,
  addSystemToUserRequest,
  deleteSystemFromUserRequest,
  deleteMultipleSystemsRequest,
  uploadUserLogoRequest,
  deleteUserLogoRequest,
  sendUserOccurrenceRequest,
  confirmUserNewsRequest,
  confirmRecipientRequest,
  confirmTrustedUserRequest,
  checkTrustedUserStatusRequest,
  addAlertRecipientRequest,
  deleteAlertRecipientRequest,
  deleteAccountRequest,
  manageTrustedUsersRequest,
  deleteCollaborativeAccessRequest,
  addCollaborativeAccountRequest,
  editCollaborativeAccountRequest
}
